import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateGroupedGeneralOrdersReportInput } from './GenerateGroupedGeneralOrdersReportInput';
import { GenerateGroupedGeneralOrdersReportOutput } from './GenerateGroupedGeneralOrdersReportOutput';

export class GenerateGroupedGeneralOrdersReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateGroupedGeneralOrdersReportInput) => {
    this.http.postToDownloadFile<GenerateGroupedGeneralOrdersReportInput>(
      `${this.baseUrlSislogApi}/v2/report-grouped-general-orders`,
      input
    ).then(result => {
      this.report.download(result, `${strings.GroupedGeneralReport}.csv`);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }

  handleCsvOrders = (input: GenerateGroupedGeneralOrdersReportInput): Promise<Result<GenerateGroupedGeneralOrdersReportOutput> | null> => {
    const promise = this.http.post<Result<GenerateGroupedGeneralOrdersReportOutput>, GenerateGroupedGeneralOrdersReportInput>(
      `${this.baseUrlSislogApi}/v2/report-grouped-general-orders/csv-orders`,
      input
    );
    return promise;
  }

}